// import RepositoryFactory from "@/apis";
// const Doctor = RepositoryFactory.doctor;
import Doctor from "../../apis/doctor";

export default {
  createDoctor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Doctor.createDoctor(payload);
        // commit("CREATE_DOCTOR", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getDoctor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Doctor.getDoctor(payload);

        commit("GET_DOCTOR", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteDoctor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Doctor.deleteDoctor(payload);
        // commit("DELETE_DOCTOR", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editDoctor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Doctor.editDoctor(payload);
        // commit("EDIT_DOCTOR", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
